export const USERS_DATA = "USERS_DATA";
export const USERS_LOADED = "USERS_LOADED";
export const USERS_ERROR = "USERS_ERROR";

const defaultState = {
	data: null,
	loaded: false,
	error: null
};

export default function customersReducer(state = defaultState, action) {
	switch (action.type) {
		case USERS_DATA:
			return { ...state, data: { ...state.data, ...action.payload } };
		case USERS_LOADED:
			return { ...state, loaded: action.payload };
		case USERS_ERROR:
			return { ...state, error: action.payload };
		default:
			return state;
	}
}